import PartnerContractList from './contract.vue'
export default PartnerContractList
